import { forwardRef, type ComponentPropsWithRef } from "react";
import {
  CoreTooltipIconButton,
  type PropsWithOptionalTestID,
} from "@boi/components-core";

import * as S from "./TooltipIconButton.styled";
import { useTooltipContext } from "../Tooltip/Tooltip";

export type TooltipIconButtonProps = PropsWithOptionalTestID &
  Omit<
    ComponentPropsWithRef<"button">,
    "style" | "className" | "children" | "aria-expanded"
  > & {
    variant?: CoreTooltipIconButton.Variant;
    "aria-label": string;
  };

const TooltipIconButton = forwardRef<HTMLButtonElement, TooltipIconButtonProps>(
  (props, ref) => {
    const {
      variant = CoreTooltipIconButton.DEFAULT_VARIANT,
      testID = "tooltip-icon-button",
      ...otherProps
    } = props;

    const { open, isControlled } = useTooltipContext();

    return (
      <S.Button
        {...otherProps}
        ref={ref}
        aria-expanded={isControlled ? open : undefined}
        $isControlled={isControlled}
        $variant={variant}
        type="button"
        data-testid={testID}
      >
        <S.Container $variant={variant}>
          <S.Icon
            $isControlled={isControlled}
            $isOpen={open}
            $variant={variant}
          />

          <S.IconFilled
            $isControlled={isControlled}
            $isOpen={open}
            $variant={variant}
          />
        </S.Container>
      </S.Button>
    );
  }
);

TooltipIconButton.displayName = "TooltipIconButton";

export default TooltipIconButton;
